import { AlertCircle, Inbox, LoaderCircle } from 'lucide-react'
import { Button } from './Button'
export { Input, Select, Textarea } from './FormField'

export function PageLoading({ label = 'Memuatkan kandungan' }: { label?: string }) {
  return (
    <div className="state state--compact" role="status">
      <LoaderCircle className="spin" /> <span>{label}…</span>
    </div>
  )
}

export function SkeletonRows({ count = 5 }: { count?: number }) {
  return (
    <div aria-label="Kandungan sedang dimuatkan" role="status" className="skeleton-list">
      {Array.from({ length: count }, (_, index) => (
        <div className="skeleton-row" key={index}>
          <span />
          <span />
          <span />
        </div>
      ))}
    </div>
  )
}

export function EmptyState({
  title,
  message,
  action,
}: {
  title: string
  message: string
  action?: React.ReactNode
}) {
  return (
    <div className="state">
      <Inbox aria-hidden="true" />
      <h2>{title}</h2>
      <p>{message}</p>
      {action}
    </div>
  )
}

export function ErrorState({ error, retry }: { error: unknown; retry?: () => void }) {
  const message =
    error instanceof Error ? error.message : 'Sesuatu tidak berjalan seperti dijangka.'
  return (
    <div className="state state--error" role="alert">
      <AlertCircle aria-hidden="true" />
      <h2>Tidak dapat memuatkan kandungan</h2>
      <p>{message}</p>
      {retry ? (
        <Button variant="secondary" onClick={retry}>
          Cuba lagi
        </Button>
      ) : null}
    </div>
  )
}

export function ErrorSummary({ errors }: { errors: string[] }) {
  if (!errors.length) return null
  return (
    <div className="error-summary" role="alert" tabIndex={-1}>
      <strong>Semak maklumat berikut:</strong>
      <ul>
        {errors.map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    </div>
  )
}
